import { customerTestInstance } from '../axios';

const updateCustomerDetails = (updatedCustomerDetails: any) =>
  customerTestInstance.put('/customer/updateRK', updatedCustomerDetails);

export default updateCustomerDetails;
